import { render, staticRenderFns } from "./MaterialLightbox.vue?vue&type=template&id=6cf99d0a&scoped=true&"
import script from "./MaterialLightbox.vue?vue&type=script&lang=js&"
export * from "./MaterialLightbox.vue?vue&type=script&lang=js&"
import style0 from "./MaterialLightbox.vue?vue&type=style&index=0&id=6cf99d0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf99d0a",
  null
  
)

export default component.exports